export default __webpack_public_path__ + "static/media/melissa_kang.781e6481.jpg";